import * as React from "react";
import { withTranslation } from "react-i18next";
import { ListWrapper, ListSection, List, ListTitle, ListItem } from "../list/index";
class DishIngredientsListClass extends React.Component {
    render() {
        const { ingredients, t } = this.props;
        const totalUnchecked = ingredients.reduce((total, i) => total + (i.active ? 0 : 1), 0);
        if (totalUnchecked === 0)
            return null;
        return (React.createElement(ListWrapper, null,
            React.createElement(ListTitle, null, t("order.receipt.dishes.remove_ingredients")),
            React.createElement(ListSection, { className: "m-t-2" },
                React.createElement(List, null, ingredients.map((ing, i) => {
                    if (ing.active)
                        return null;
                    return (React.createElement(ListItem, { key: i, className: "r-list-item" }, ing.name));
                })))));
    }
}
export const DishIngredientsList = withTranslation()(DishIngredientsListClass);
//# sourceMappingURL=index.js.map